import { Languages } from "lucide-react";
import { TARGET_LANGUAGES, type TargetLanguage } from "../shared/languages";
import { UI_COPY } from "../shared/uiCopy";

export type LanguagePickerProps = {
  value: TargetLanguage;
  onChange(value: TargetLanguage): void;
};

export function LanguagePicker({ value, onChange }: LanguagePickerProps) {
  const copy = UI_COPY[value];

  return (
    <fieldset className="language-picker">
      <legend className="sr-only">{copy.outputLanguagePrompt}</legend>
      <div className="language-picker__label" aria-hidden="true">
        <Languages size={16} strokeWidth={1.8} />
        <span>{copy.outputLanguageHelp}</span>
      </div>
      <div className="language-picker__tabs">
        {TARGET_LANGUAGES.map((language) => (
          <button
            className="language-picker__tab"
            type="button"
            aria-pressed={value === language.value}
            key={language.value}
            lang={language.value === "zh" ? "zh-CN" : language.value}
            onClick={() => onChange(language.value)}
          >
            {language.nativeLabel}
          </button>
        ))}
      </div>
    </fieldset>
  );
}
